<template>
  <ODialog
    ref="dialog"
    :title="$t('pass.deleteCustomer')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('pass.delete'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :loading="loading"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { CustomerPass } from '~/_api/models/customerPass'

interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $bus } = useNuxtApp()

const dialog = ref()
const item = ref<CustomerPass | null>(null)

const info = computed(() => {
  return $i18n.t('components.customerPass.actions.delete.info')
})

const open = (customerPassItem: CustomerPass) => {
  item.value = customerPassItem
  dialog.value.open()
}

const confirm = async () => {
  if (!item.value) return

  emit('update:loading', true)

  try {
    const response = await $api.customerPass.delete(item.value)

    if (response.success) {
      emit('success')

      $bus.emit.deleted('CustomerPass', item.value)

      $notification.toast({
        title: $i18n.t('pass.deletedSuccess'),
        text: $i18n.t('components.customerPass.actions.delete.successInfo'),
        variant: 'success',
      })

      emit('update:loading', false)

      return true
    }
  } catch (e) {
    console.log(e)
    $notification.error(e)
  }

  emit('update:loading', false)
}

defineExpose({
  open,
})
</script>
